import { cn } from '../lib/cn.ts'
import { LOGO } from './icons/paths.ts'

/**
 * The mark: a lowercase t whose crossbar is a swipe of the amber highlighter. Same drawing as the
 * favicon and the landing pages (icons/paths.ts).
 */
export function Logo({ size = 'md', className }: { size?: 'md' | 'lg'; className?: string }) {
	return (
		<svg
			viewBox="0 0 32 32"
			className={cn('shrink-0', size === 'lg' ? 'size-12' : 'size-8', className)}
			aria-hidden="true"
		>
			<rect width="32" height="32" rx="9" className="fill-teal-700" />
			<path d={LOGO.marker} className="stroke-amber-500" strokeWidth={5} strokeLinecap="round" />
			<path
				d={LOGO.t}
				fill="none"
				stroke="#fff"
				strokeWidth={3.6}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

/** The mark plus the name, for anywhere the product has to introduce itself. */
export function Wordmark({ size = 'md' }: { size?: 'md' | 'lg' }) {
	return (
		<span className="inline-flex items-center gap-2 text-h3 font-semibold tracking-tight text-ink">
			<Logo size={size === 'lg' ? 'lg' : 'md'} />
			Temaly
		</span>
	)
}
